import { z } from 'zod';

export const parametroSistemaInputSchema = z.object({
  nome: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
  casasDecimaisApontamento: z
    .number()
    .int('Apenas inteiros')
    .min(0, 'Mínimo 0')
    .max(6, 'Máximo 6')
    .nullable()
    .optional(),
  chaveEmailSite: z.string().trim().max(200).nullable().optional(),
  tipoApontamentoHora: z.enum(['INIFIM', 'TOTAL']).nullable().optional(),
});

export type ParametroSistemaFormValues = z.infer<typeof parametroSistemaInputSchema>;
